import { useState } from "react";

const SHARE_URL = "https://joinfsl.com";

export function ThankYou(): JSX.Element {
  const [label, setLabel] = useState("Share joinfsl.com");

  const onShare = async (): Promise<void> => {
    try {
      if (typeof navigator !== "undefined" && "share" in navigator) {
        await navigator.share({ title: "Fake Sports League", url: SHARE_URL });
        return;
      }
    } catch {
      // user cancelled; fall through to copy
    }
    if (typeof navigator !== "undefined" && navigator.clipboard) {
      await navigator.clipboard.writeText(SHARE_URL);
      setLabel("Copied ✓");
      window.setTimeout(() => setLabel("Share joinfsl.com"), 2000);
    }
  };

  return (
    <div className="step active thanks" data-step="thanks">
      <h2 className="thanks-title">
        You're in<span className="dot">.</span>
      </h2>
      <p>We'll email you as soon as Fall 2026 enrollment opens.</p>
      <p>Until then, we're building in public. You'll hear from us when it matters, and not before.</p>
      <div className="share-block">
        <h3>Know another family who should skip the youth-sports trap?</h3>
        <p>Send them over.</p>
        <button type="button" className="btn btn-primary" onClick={onShare}>
          {label}
        </button>
      </div>
    </div>
  );
}
